module.exports = __webpack_public_path__ + "static/WEDDING E&M-372-3008e07c03470ab4cdd39e49c91d108f.jpg";